import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Panel, Button, Modal } from 'react-bootstrap';
import './connections.less';
import { connectIntegration, disconnectIntegration } from '../../redux/actions/integrationsConnectionActions';
import skyDriveIcon from './icons/onedrive.png';
import OneDriveAuthenticator from "./OneDriveAuthenticator";
import { notify } from 'common/Notification';

export default class OneDriveSwitch extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
    showTypeChooser: false,
  };

  handleShowChooser = () => {
    this.setState({ showTypeChooser: true });
  };

  handleHideChooser = () => {
    this.setState({ showTypeChooser: false });
  };

  connectOneDrive = (type) => {
    this.setState({showTypeChooser: false, loading: true});

    const fileScope = type === 'appFolder' ? 'appfiles' : 'files';

    OneDriveAuthenticator(type)
      .login({
        scope: fileScope + ' groups sites offline',
        state: {
          connection_type: type,
          redirect_host: window.location.host,
        }
      })
      .then(
        ({ authResponse }) => {
          this.props.dispatch(connectIntegration('files', 'onedrive', authResponse));
          this.setState({ loading: false });
        },
        (res) => {
          const { code, message } = res.error;
          this.setState({ loading: false });
          notify.error(`Error connecting to One Drive: [${code}] ${message || ''}`);
        }
      )
  };

  onClick = () => {
    const { connectionId } = this.props;

    if (connectionId === null) {
      // Show the connection type chooser
      this.handleShowChooser();
      return;
    }
    else {
      // turn off the integration
      this.props.dispatch(disconnectIntegration(connectionId));
    }
  }

  render() {
    const { connectionId, agreedToPricing } = this.props;
    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2" >
        <img className="kloudless-connection-icon"
             src={skyDriveIcon}
             alt="Google Drive Logo"
        />

        <div className={iconCls} onClick={this.onClick} >
          { this.state.loading
          && <i
            className={"fa fa-circle-o-notch fa-spin"}
            style={{ marginTop: '10px', marginLeft: '11px', fontSize: '11px' }}

          />}
        </div>

        <Modal show={this.state.showTypeChooser} onHide={this.handleHideChooser}>
          <Modal.Header closeButton>
            <Modal.Title>Choose OneDrive Integration Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel>
              <Panel.Heading>App Folder <strong>OneDrive/Apps/CourtDrive</strong></Panel.Heading>
              <Panel.Body>
                <p>Files will be uploaded to OneDrive under the folder Apps/CourtDrive.
                  <strong>CourtDrive will not be able to read or write any files outside of this folder.</strong>
                </p>
                <Button bsStyle="primary" onClick={() => this.connectOneDrive('appFolder')}>Choose App Folder</Button>
              </Panel.Body>
            </Panel>

            <Panel>
              <Panel.Heading>Full Access <strong>OneDrive/CourtDrive</strong></Panel.Heading>
              <Panel.Body>
                <p>Files will be uploaded to OneDrive under a folder name that you choose at the top of your OneDrive folder.
                  <strong>CourtDrive will need read and write access to your entire OneDrive for this.</strong>
                </p>
                <Button bsStyle="primary" onClick={() => this.connectOneDrive('full')}>Choose Full Access</Button>
              </Panel.Body>
            </Panel>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/OneDriveSwitch.jsx